import { PAYMENT_METHODS, SHIPPING_METHODS } from "../const";

import * as yup from "yup";
import { setLocale } from "yup";

setLocale({
  mixed: {
    required: "field.required",
  },
  string: {
    email: "field.email",
  },
});

export const reviewFormSchema = yup.object().shape({
  name: yup.string().required(),
  email: yup.string().email().required(),
  content: yup.string().required(),
  rating: yup.number().min(0).max(5).required(),
  recaptcha: yup.string().required(),
});

export const paymentValidationSchema = yup.object().shape({
  payment: yup
    .string()
    .nullable()
    .required()
    .oneOf(PAYMENT_METHODS.map((x) => x.slug)),
});

export const contactFormValidation = yup.object().shape({
  name: yup.string().required(),
  email: yup.string().email().required(),
  message: yup.string().required(),
  recaptcha: yup.string().required(),
});

export const orderValidationSchema = yup.object().shape({
  firstName: yup.string().required(),
  lastName: yup.string().required(),
  address: yup.string().required(),
  zipcode: yup.string().required(),
  city: yup.string().required(),

  email: yup.string().email().required(),
  phone: yup.string().required(),

  delivery: yup
    .string()
    .ensure()
    .required()
    .oneOf(SHIPPING_METHODS.map((x) => x.slug)),
  deliveryDetails: yup.string().when("delivery", (delivery, schema) => {
    return delivery === "paczkomat" ? schema.required() : schema;
  }),
  payment: yup
    .string()
    .nullable()
    .required()
    .oneOf(PAYMENT_METHODS.map((x) => x.slug)),

  rules: yup.boolean().required().oneOf([true]),
  rodo: yup.boolean().required().oneOf([true]),
});
